/* global CONFIG */
// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import VueI18n from 'vue-i18n'
// import * as VueGoogleMaps from 'vue2-google-maps'
import App from './components/App'
import router from './router'
import store from './store'

import OpoliGatewaySDK from './modules/gateway-sdk'
import OpoliPlugins from './modules/plugins'

import VueResource from 'vue-resource'
import VueDragDrop from 'vue-drag-drop'

import messages from './lang'
console.log('APP CONFIG', CONFIG)

Vue.config.productionTip = false
// Vue.use(VueGoogleMaps, {
//   load: {
//     key: CONFIG.googleApiKey,
//     libraries: 'places' // This is required if you use the Autocomplete plugin
//     // OR: libraries: 'places,drawing'
//     // OR: libraries: 'places,drawing,visualization'
//     // (as you require)
//   }
// })

Vue.use(VueResource)
Vue.use(VueDragDrop)

// Vue.use(OpoliGatewaySDK, CONFIG.Gateway)
Vue.use(OpoliGatewaySDK, Object.assign(CONFIG.Gateway, { optimizationHost: CONFIG.optimizationHost }))
Vue.use(OpoliPlugins)

Vue.use(VueI18n)
let path = window.location.pathname
let language = 'en'
if (path !== '/' && path.length > 3) {
  language = path.substring(1, 3)
}
let i18n = new VueI18n({
  locale: language, // set locale
  messages // set locale messages
})

// Create the directive
Vue.directive('click-outside', {
  bind(el, binding, vnode) {
    el.clickOutsideEvent = function(event) {
      // Check if click was outside the element and its children
      if (!(el === event.target || el.contains(event.target))) {
        // Call the provided method
        vnode.context[binding.expression](event)
      }
    }
    document.addEventListener('click', el.clickOutsideEvent)
  },
  unbind(el) {
    document.removeEventListener('click', el.clickOutsideEvent)
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  i18n,
  template: '<App/>',
  components: { App }
})



// WEBPACK FOOTER //
// ./src/main.js